module.exports = __webpack_public_path__ + "media/images/contacto/telefono-b9cb497fec4b6d83d7bffbf8fe4d6bb3.svg";